export default __webpack_public_path__ + "static/char-s-49-ko-b813d3360028ee78f5c4f6f2db400883.webp";